import React, { useRef, useEffect, memo } from 'react'
import { Popover } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { ASRItem, CallInfo } from 'src/types/ai-assistant'
import { getStaffName } from 'src/library/utils'
import moment from 'moment'
import { UserInfo } from '@types'
import { callWorkbenchStore } from '../store'
// 保留原 Hook 导入用于对比或兼容
// import CallWorkbenchContainerLegacy from '../useCallWorkbenchHook'
import { ModuleNameMapping } from '@configs/constants'

const ASRContent = memo(({ asrList, callInfo, userInfo }: { asrList: ASRItem[]; callInfo: CallInfo; userInfo: UserInfo; }) => {
  // 新 Zustand Store 的方法
  const searchNodeLoading = callWorkbenchStore(s => s.searchNodeLoading)
  const getAISearchNode = callWorkbenchStore(s => s.getAISearchNode)

  // 原 Hook 的别名引用（用于对比或兼容）
  // const {
  //   searchNodeLoading: hookSearchNodeLoading,
  //   getAISearchNode: hookGetAISearchNode,
  // } = CallWorkbenchContainerLegacy.useContainer()

  const asrContentRef = useRef<HTMLDivElement>(null)
  // 控制有新消息时，滚动到最底部
  useEffect(() => {
    if (asrContentRef.current) {
      asrContentRef.current.scrollTop = asrContentRef.current.scrollHeight
    }
  }, [asrList])

  const handleAiSearch = (item: ASRItem, currentIndex: number) => () => {
    if (searchNodeLoading) {
      return
    }
    const messageCount = 10
    // 获取当前消息以及前面的${messageCount}条消息
    const startIndex = Math.max(0, currentIndex + 1 - messageCount)
    const contextMessages = asrList.slice(startIndex, currentIndex + 1)?.map(item => ({ User: item.flow === 'OUT' ? '坐席' : '客户', Msg: item.message }))
    getAISearchNode({ type: 'qa', content: JSON.stringify(contextMessages), label: item.message })
    window.XSY_TRACK?.trackClick('communication_assistant', {
      content: {
        belong_module: userInfo?.belongModule,
        belong_module_name: ModuleNameMapping[userInfo?.belongModule],
        follower: getStaffName(userInfo.salesName, userInfo.salesNameCh),
        communication_assistant_record_id: callInfo?.recordId,
        communication_assistant_lead_id: callInfo?.leadId,
        communication_assistant_cid: callInfo?.cid,
        communication_assistant_type: 'asrSearch',
        communication_assistant_value: JSON.stringify(contextMessages),
      },
    })
  }
  return (
    <div className="asr-content" ref={asrContentRef}>
      {
        asrList.map((item, index) => (
          <div
            key={index}
            className={`message-item ${item.flow === 'OUT' ? 'self' : 'other'}`}
          >
            <div className="message-sender">
              {item.flow === 'OUT' ? getStaffName(userInfo?.salesName, userInfo?.salesNameCh) : (callInfo.calleeName || '客户')}
            </div>
            <div className="message-time">
              {moment(item.timestamp).format('YYYY-MM-DD hh:mm:ss')}
            </div>
            <div className={`message-bubble-container ${item.flow === 'OUT' ? 'self' : 'other'}`}>
              <div className="message-bubble">
                {item.message}
              </div>
              {
                item.sliceType === 2
                && (
                  <Popover color="#000" content={<div style={{ color: '#fff' }}>点击以基于此对话上下文进行AI问答</div>}><SearchOutlined onClick={handleAiSearch(item, index)} style={{ cursor: searchNodeLoading ? 'not-allowed' : 'pointer' }} className="message-search-icon" /></Popover>
                )
              }
            </div>
          </div>
        ))
      }
    </div>
  )
})

export default ASRContent
